<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "LincMobile",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
